import { GenericLazyString, gettext } from '@eventbrite/i18n';
import React from 'react';
import styles from './HeroTitle.module.scss';

export interface HeroTitleProps {
    title: string | GenericLazyString;
}

export const HeroTitle: React.FC<HeroTitleProps> = (props) => {
    const { title } = props;

    return (
        <div className={styles.heroTitle}>
            <h1 className={styles.heroHeading}>
                <p className={styles.textContainer}>
                    <span className={styles.orangeText}>
                        {gettext('EVENTS AND THINGS TO DO NEAR')}
                    </span>
                </p>

                <p className={styles.textContainer}>
                    <span className={styles.greenBackgroundText}>
                        {title.toLocaleUpperCase()}
                    </span>
                </p>
            </h1>
        </div>
    );
};
